export const links = {
	// AUTH ENDPOINTS
	login: 'login',
	loginVerify: 'verify-login',
	forgotPassword: 'forgot-password',
	resetPassword: 'reset-password',
	createAccount: 'create-account',
	createToken: 'create-verification-token',
	checkToken: 'check-verification-token',
	// INVITES ENDPOINTS
	listInvites: 'invites/invitations',
	createInvites: 'invites/create-invite',
	deleteInvites: 'invites/delete-invite',
	// ACCOUNT ENDPOINTS
	accountProfile: 'account/profile',
	changePassword: 'account/change-password',
	signOut: 'account/logout',
	updateAccount: 'account/update-profile',
	toggleTFA: 'account/toggle-2-factor',
	// ADMIN ENDPOINTS
	admins: '',
	adminSimple: 'simple',
	viewAdmin: 'view-admin',
	changeAdminStatus: 'change-status',
	editAdmin: 'edit-admin',
	deleteAdmin: 'delete-admin',
	// API CALLS ENDPOINTS
	apiCalls: 'api-calls',
	deleteApiCalls: 'api-calls/delete-api-call',
	// COMPANIES ENDPOINTS
	companies: 'companies',
	changeCompanyStatus: 'companies/change-status',
	changeCompanyApprovalStatus: 'companies/change-approval-status',
	deleteCompany: 'companies/delete-company',
	teams: 'companies/company-teams',
	addCompanyProducts: 'companies/create-company-products',
	// CURRENCIES ENDPOINTS
	currencies: 'currencies',
	currencySimple: 'currencies/simple',
	createCurrency: 'currencies/create-currency',
	editCurrency: 'currencies/edit-currency',
	deleteCurrency: 'currencies/delete-currency',
	// CUSTOMERS ENDPOINTS
	customers: 'customers',
	changeCustomerStatus: 'customers/change-status',
	deleteCustomer: 'customers/delete-user',
	// CUSTOMER NOTIFICATIONS
	customerNotifications: 'customer-notifications',
	// CUSTOMER PLANS
	customerPlans: 'customer-plans',
	simpleCustomerPlans: 'customer-plans/simple',
	createCustomerPlan: 'customer-plans/create-plans',
	editCustomerPlan: 'customer-plans/edit-plan',
	deleteCustomerPlan: 'customer-plans/delete-plan',
	// DASHBOARD
	dashboard: 'dashboard',
	// INVOICES
	invoices: 'invoices',
	createInvoice: 'invoices/create-invoice',
	editInvoice: 'invoices/edit-invoice',
	deleteInvoice: 'invoices/delete-invoice',
	downloadInvoice: 'invoices/download-invoice',
	// PLANS
	plans: 'plans',
	planSimple: 'plans/simple',
	createPlan: 'plans/create-plans',
	editPlan: 'plans/edit-plan',
	deletePlan: 'plans/delete-plan',
	// PRODUCTS
	products: 'products',
	productSimple: 'products/simple',
	createProduct: 'products/create-products',
	editProduct: 'products/edit-product',
	deleteProduct: 'products/delete-product',
	// PROJECTS
	projects: 'projects',
	changeProjectStatus: 'projects/change-status',
	deleteProject: 'projects/delete-project',
	// ROLES
	roles: 'roles',
	roleSimple: 'roles/simple',
	createRole: 'roles/create-role',
	editRole: 'roles/edit-role',
	deleteRole: 'roles/delete-role',
	permissions: 'permissions',
	// SYSTEM API KEYS
	systemApiKeys: 'system-api-keys',
	createSystemApiKey: 'system-api-keys/create-key',
	editSystemApiKey: 'system-api-keys/edit-key',
	deleteSystemApiKey: 'system-api-keys/delete-key',
	// TRANSACTIONS
	transactions: 'transactions',
	deleteTransaction: 'transactions/delete-transaction',
	// USERS
	users: 'users',
	changeUserStatus: 'users/change-status',
	deleteUser: 'users/delete-user',
	companiesUser: 'users/companies',
	// WALLETS
	wallets: 'wallets',
	debitWallet: 'wallets/debit',
	creditWallet: 'wallets/credit',
};
